import { render } from "./BannerUpComp.vue?vue&type=template&id=5a667e79&scoped=true"
import script from "./BannerUpComp.vue?vue&type=script&lang=js"
export * from "./BannerUpComp.vue?vue&type=script&lang=js"

import "./BannerUpComp.vue?vue&type=style&index=0&id=5a667e79&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a667e79"]])

export default __exports__